module.exports = __webpack_public_path__ + "static/media/intellync_logo_new.fddbe4e4.png";